(function() {
    'use strict';

    angular
        .module('app.installations')
        .component('accreditationWarning', accreditationWarning());

    function accreditationWarning() {
        return {
            restrict: 'E',
            controllerAs: 'vm',
            templateUrl: 'app/installations/common/accreditationWarning.html',
            bindings: {
                show: '<'
            }
        };
    }
})();